import React, { useEffect, useState } from 'react';
import { SingleProps } from './Handbooks.types';
import { Styled } from './Handbooks.styles';
import { getList as getListRequest, ITableRequest } from 'api/handbooks/table';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { PageHeader } from '../components/PageHeader';
import { MapForm } from './components/MapForm';
import { NavLink } from 'react-router-dom';
import { convertMinutesToTime } from 'views/components/SpreadSheet/utils';
import { useHistory } from 'react-router';

import {
  BackButton,
} from '../components/NavigationButton';

import moment       from 'moment';
import { Page }     from '../components/Page';
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const getFilter = (config: any, id: number): ITableRequest => {
  const indexField = config.fields.find((el: any) => !!el.index).name;

  return {
    schema: config.schema,
    table: config.table,
    fields: config.fields
      .filter((el: any) => !!el.name)
      .map((el: { name: string }) => el.name),
    sort: config.defaultSort,
    limit: 1,
    offset: 0,
    filters: `${indexField}=${id}`,
    apiType: apiTypes.DEFAULT,
  };
};

const getConnectionName = (
  list: any,
  config: any,
  connectionName: string,
  index: any
): string => {
  const cn = list.find(
    (cl: any) => cl[config.connections[connectionName].index] == index
  );
  // console.log('connectionn', list, connectionName, index, cn);
  if (cn) {
    return config.connections[connectionName].format(cn);
  }
  return index;
};

const getListName = (list: any[], index: any) => {
  const vl = list.find((elem: { key: any; value: any }) => elem.key === index);
  if (vl) {
    return vl.value;
  }
  return index;
};

const getFormatedField = (field: any, value: string) => {
  if (field.type === 'date') {
    return (value && moment(value).format('DD.MM.YYYY')) || '';
  }
  if (field.type === 'timeminutes') {
    return value && convertMinutesToTime(parseInt(value));
  }
  if (field.type === 'boolean') {
    return (value && 'Да') || 'Нет';
  }
  return (value || '') + '';
};

const getFieldText = (
  index: any,
  props: SingleProps,
  field: any,
  config: any
) => {
  return field.connection
    ? getConnectionName(
        (props.connections && props.connections[field.connection]) || [],
        config,
        field.connection,
        index
      )
    : field.type === 'list'
    ? getListName(field.values || [], index)
    : getFormatedField(field, index);
};

export const HandbookSingle: React.FC<SingleProps> = (props: SingleProps) => {
  const [isPreloaderShown, showPreloader] = useState(true);
  const [data, setData] = useState<any>(null);
  const config = props.config;
  const connections = props.connections;

  const history = useHistory();

  const loadData = async () => {
    showPreloader(true);
    const data = await getListRequest(getFilter(config, props.id));
    if (data && data.list && data.list.length > 0) {
      setData(data.list[0]);
    }
    showPreloader(false);
  };

  useEffect(() => {
    loadData();
  }, [props.type, props.id]);

  return (
    <Page title={config.title}
      primaryButtonNode={<BackButton onClick={() => history.push(`/handbooks/${props.type}`)} />}>
      {isPreloaderShown ? (
        <Styled.Preloader>
          <Spinner size={SpinnerSize.large} />
        </Styled.Preloader>
      ) : !data ? (
        <Styled.EmptyElem>По вашему запросу ничего не найдено</Styled.EmptyElem>
      ) : (
        <Styled.SigleElem>
          <Styled.ListItemIndex>
            {data[props.indexFieldName]}
          </Styled.ListItemIndex>
          <Styled.ListItemTitle>
            {config.makeTitle(data, connections)}
          </Styled.ListItemTitle>
          {config.fields.map((el: any) => {
            return el.hide ? (
              <></>
            ) : el.type === 'map' ? (
              <MapForm field={el} data={data} />
            ) : (
              <Styled.PropsElem>
                <label>{el.title}:</label>&nbsp;
                {el.link ? (
                  <NavLink to={`/handbooks/${el.link}/${data[el.name]}`}>
                    {getFieldText(data[el.name], props, el, config)}
                  </NavLink>
                ) : (
                  <span>{getFieldText(data[el.name], props, el, config)}</span>
                )}
              </Styled.PropsElem>
            );
          })}
        </Styled.SigleElem>
      )}
    </Page>
  );
};
